import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';

const Rep_ctr = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, setToDate] = useState(new Date());
    const [generateType, setGenerateType] = useState("D");

    const [locationCode, setLocationCode] = useState(0);
    const [selectedItems, setSelectedItems] = useState([]);
    const [radioType, setRadioType] = useState("O");
    const [reportType, setReportType] = useState("I");
    const [amount, setAmount] = useState("1000000");
    const [filterBtTransaction, setFilterBtTransaction] = useState(true);
    const [filterPan, setFilterPan] = useState(true);
    const [aboveAmountFilter, setAboveAmountFilter] = useState("50000");
    const [hdrSrno, setHdrSrno] = useState("");
    const [refno, setRefno] = useState("");

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'REP_CTR'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleDataFromChild = (newLocationCode, newSelectedItems, newRadioType) => {
        setLocationCode(newLocationCode);
        setSelectedItems(newSelectedItems);
        setRadioType(newRadioType);
    }

    const handleGenerate = () => {
        $(".loader").show();
        if (!Common.validateFinYear(Common.dateYMD(fromDate), Common.dateYMD(toDate))) {
            $(".loader").hide();
            setMsgBox(true);
            setMsgText("Date should be within financial year");
            return;
        } else if (fromDate > toDate) {
            $(".loader").hide();
            setMsgText("From Date should be less than To Date");
            setMsgBox(true);
            return;
        }

        var msg = [], i = 0;
        if (refno === "" || amount === "" || aboveAmountFilter === "") {
            msg[i++] = (refno === "" ? "Reference number." : '');
            msg[i++] = (amount === "" ? "Amount." : '');
            msg[i++] = (aboveAmountFilter === "" ? "Above amount." : '');
            $(".loader").hide();
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                fromDate: Common.dateYMD(fromDate),
                toDate: Common.dateYMD(toDate),
                type: generateType,
                radioTypeLocation: radioType,
                location: locationCode,
                multipleLocation: selectedItems,
                fromDateDMY: Common.dateDMY(fromDate),
                toDateDMY: Common.dateDMY(toDate),
                aboveAmount: aboveAmountFilter,
                amount: amount,
                filterBtTransaction: filterBtTransaction,
                filterPan: filterPan,
                refno: refno

            };
            Common.callApi(Common.apiRepCtr, [sid, "insertactivitylog", JSON.stringify(obj)], result => {
                let resp = JSON.parse(result);
                setHdrSrno(resp.srno);
                // if (resp.srno * 1 > 0) {
                if (generateType === 'D') {
                    Common.callDownloadApiPost1(Common.apiRepCtr, "post", [sid, "downloadindividual", JSON.stringify(obj), resp.srno], result => {
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                        Common.callDownloadApiPost1(Common.apiRepCtr, "post", [sid, "downloadcorporate", JSON.stringify(obj), resp.srno], result => {
                            setMsgText(Common.buildMessageFromArray([result]));
                            setMsgBox(true);
                            Common.callDownloadApiPost1(Common.apiRepCtr, "post", [sid, "downloadtransaction", JSON.stringify(obj), resp.srno], result => {
                                setMsgText(Common.buildMessageFromArray([result]));
                                setMsgBox(true);
                                Common.callDownloadApiPost1(Common.apiRepCtr, "post", [sid, "downloadkc1", JSON.stringify(obj), resp.srno], result => {
                                    setMsgText(Common.buildMessageFromArray([result]));
                                    setMsgBox(true);
                                    $(".loader").hide();
                                    // resetFields();
                                });
                            });
                        });
                    });
                } else {
                    Common.callApi(Common.apiRepCtr, [sid, "view", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);

                    });

                }
                // }
            })
        }
    }
    const resetFields = () => {
        setRefno("");
        setAmount("");
        setAboveAmountFilter("");
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>CTR Report</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Reference Number</Form.Label>
                            <Form.Control type="text" placeholder='Reference Number' value={refno} onChange={e => Common.validateNumValue(e.target.value, setRefno)} />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>CTR Amount</Form.Label>
                            <Form.Control type="text" laceholder='Amount' value={amount} onChange={e => Common.validateNumValue(e.target.value, setAmount)} />
                        </Form.Group>
                    </Col>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Transaction Amount</Form.Label>
                            <Form.Control type="text" placeholder='Amount' value={aboveAmountFilter} onChange={e => Common.validateNumValue(e.target.value, setAboveAmountFilter)} />
                        </Form.Group>
                    </Col>
                    <Row>
                        <Row><h4>Report Period</h4></Row>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                <DatePicker className="form-control"
                                    selected={fromDate}
                                    onChange={(date) => setFromDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown

                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                <DatePicker className="form-control"
                                    selected={toDate}
                                    onChange={(date) => setToDate(date)}
                                    dateFormat="dd/MM/yyyy"
                                    showYearDropdown
                                    showMonthDropdown
                                    useShortMonthInDropdown
                                    dropdownMode="select"
                                    peekNextMonth
                                    customInput={
                                        <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row><h4>Report View</h4></Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={generateType} onChange={e => setGenerateType(e.target.value)}
                                required>
                                <option value="D">Download</option>
                                {/* <option value="V">View</option> */}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>

            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Rep_ctr;